export default __webpack_public_path__ + "static/media/whatsapp.63ba4fe1.jpg";